// spacial dom id
export const FIXED_CONTAINER_ID = 'FIXED_CONTAINER_ID';
export const EASY_EMAIL_EDITOR_ID = 'bay-email-editor';
export const PLUGINS_CONTAINER_ID = 'bay-email-plugins';
export const SYNC_SCROLL_ELEMENT_CLASS_NAME = 'bay-email-sync-scroll';
export const RICH_TEXT_BAR_ID = 'bay-email-rich-text-bar';

export const DATA_RENDER_COUNT = 'data-render-count';
export const DATA_ATTRIBUTE_ID = 'data-tree-node-id';
export const DATA_ATTRIBUTE_INDEX = 'data-tree-node-index';
export const DATA_ATTRIBUTE_DROP_CONTAINER = 'data-drop-container';

// rich text bar class name

export const DATA_CONTENT_EDITABLE_TYPE = 'data-content_editable-type';
export const DATA_CONTENT_EDITABLE_IDX = 'data-content_editable-idx';

export const CONTENT_EDITABLE_CLASS_NAME = 'bay-email-content_editable_text_only';
export const CONTENT_EDITABLE_RICH_TEXT_CLASS_NAME = 'bay-email-content_editable_rich_text';

export enum ContentEditableType {
  RichText = 'rich_text',
  Text = 'text',
}